module.exports = __webpack_public_path__ + "static/media/Shop-By-Tire-Size-Red.d3df72d0.svg";